import styled from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

export const FollowUpSection = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 2px 2px 4px 1px rgba(0, 76, 127, 0.25);
  background-color: white;
  padding-bottom: 30px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: center;
`;

export const RowHeader = styled.div`
  background-color: #084987;
  justify-content: space-between;
  padding: 0px 0px;
  font-size: 16px;
  font-weight: 700;
  border-radius: 5px 5px 0px 0px;
`;

export const EnquiryHeader = styled.div`
  justify-content: space-between;
  font-size: 16px;
  font-weight: 700;
`;

export const FollowUpPadding = styled.section`
  padding: 0 20px;
`;

export const HeaderTitle = styled.h2`
  color: #00aeea;
  font-size: 16px;
  font-family: lato;
  text-transform: initial;
  padding-top: 10px
  line-height: 1;
  margin-top: 3px;
  font-weight: bold !important;
  padding-left: 10px;
  justify-self: auto;
`;

export const Title = styled.h3`
  color: white !important;
  text-align: left;
  width: auto;
  font-family: "Lato";
  font-size: ${(props) => props.fontSize ?? "20px;"};
  line-height: 20px;
  margin: 0;
  font-weight: ${(props) => props.fontWeight ?? "normal"};
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  gap: ${(props) => props.gridGap ?? "1.25rem;"};
  margin-bottom: ${(props) => props.marginBottom ?? "10px"};
  font-weight: normal;
  margin-top: ${(props) => props.marginTop ?? "10px"};
  border-bottom: ${(props) =>
    props.borderBottom ?? "0px solid rgba(10, 73, 134, 0.3)"};
`;

export const GridItem = styled.div`
  border-right: ${(props) =>
    props.borderRight ?? "2px solid rgba(10, 73, 134, 0.3)"};
  border-left: ${(props) =>
    props.borderLeft ?? "0px solid rgba(10, 73, 134, 0.3)"};
  line-height: 2rem;
  text-align: ${(props) => props.textAlign ?? "center"};
  color: ${(props) => props.color ?? "#474747"};
  font-weight: ${(props) => props.fontWeight ?? "400"};
  background-color: ${(props) => props.backgroundColor ?? "#fff"};
  padding: ${(props) => props.padding ?? "10px"};
  font-size: ${(props) => props.fontSize ?? "16px"};
  border-top-left-radius: ${(props) => props.leftRadius ?? "0px"};
  border-top-right-radius: ${(props) => props.rightRadius ?? "0px"};
`;

export const IconGridItem = styled.div`
  border-right: ${(props) =>
    props.borderRight ?? "2px solid rgba(10, 73, 134, 0.3)"};
  border-left: ${(props) =>
    props.borderLeft ?? "0px solid rgba(10, 73, 134, 0.3)"};
  line-height: 2rem;
  text-align: ${(props) => props.textAlign ?? "center"};
  color: ${(props) => props.color ?? "#474747"};
  font-weight: ${(props) => props.fontWeight ?? "400"};
  background-color: ${(props) => props.backgroundColor ?? "#fff"};
  padding: ${(props) => props.padding ?? "10px"};
  font-size: ${(props) => props.fontSize ?? "16px"};
  border-top-left-radius: ${(props) => props.leftRadius ?? "0px"};
  border-top-right-radius: ${(props) => props.rightRadius ?? "0px"};
  display: inline-grid;
  align-items: center;
`;

export const HeaderWrapperTable = styled.div`
  background-color: ${(props) => props.color ?? "#d1e6f7"};
  display: table-column-group;
  justify-content: space-between;
  padding: 10px;
`;

export const EnquiryIdHyphen = styled.span`
  text-decoration: ${(props) => props.decoration ?? "underline"};
  cursor: pointer;
  color: ${(props) => props.color ?? "#fff"};
`;

export const GridSubLabel = styled.div`
  color: ${(props) => props.color ?? "#fff"};
  font-weight: 700;
  font-size: ${(props) => props.fontSize ?? "16px"};
  text-align: left;
`;

export const QuoteInfoAndConditionsInfo = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: ${(props) =>
    props.boxShadow ?? "2px 2px 4px 1px rgba(0, 76, 127, 0.25)"};
  background-color: white;
  padding-bottom: 30px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  padding: ${(props) => props.padding ?? "20px"};
  margin-bottom: ${(props) => props.marginBottom ?? "0px"};
`;

export const HorizontalRow = styled.div`
  border: 1px solid rgba(10, 73, 134, 0.3);
  width: 100%;
`;

export const GridSubItem = styled.div`
  color: ${(props) => props.color ?? "#0a4986"};
  font-style: ${(props) => props.fontStyle ?? "italic"};
  font-weight: ${(props) => props.fontWeight ?? "400"};
  font-size: ${(props) => props.fontSize ?? "14px"};
  text-align: ${(props) => props.textAlign ?? "left"};
  position: relative;
`;

export const GridSubItemAlign = styled.div`
  color: ${(props) => props.color ?? "#0a4986"};
  font-style: ${(props) => props.fontStyle ?? "italic"};
  font-weight: ${(props) => props.fontWeight ?? "400"};
  font-size: ${(props) => props.fontSize ?? "14px"};
  text-align: ${(props) => props.textAlign ?? "left"};
  display: ${(props) => props.display ?? "inline-grid"};
  align-items: center;
`;
